import { upload_video_chunked } from "services/db-service";

export const uploadVideoToIPFS = async ({
  file,
  user,
  setProgress = () => {},
  setPaused = () => {},
  setPausedReason = () => {},
  setLoaded = () => {}
}: {
  file: File;
  user: string;
  setProgress?: (progress: number) => void;
  setPaused?: (progress: boolean) => void;
  setPausedReason?: (message: string) => void;
  setLoaded?: (progress: any) => void;
}): Promise<{}> => { 
  const formData = new FormData();
  formData.append("video", file);
  formData.append("username", user); 

  let res = await upload_video_chunked(file, user, (e) => {
      // const percent = Math.round((e.loaded * 100) / e.total);
      setProgress(e);
  }, setPaused, setPausedReason, setLoaded);
  return res;
};

export const formatMB = (bytes) => (bytes / (1024 * 1024)).toFixed(2);

export const detectVideoOrientation = (file: File): Promise<"clip" | "video"> => {
    return new Promise((resolve) => {
      const video = document.createElement("video");
      video.preload = "metadata";
      video.onloadedmetadata = () => {
        window.URL.revokeObjectURL(video.src);
        const { videoWidth, videoHeight } = video;
        if (videoHeight > videoWidth) {
          resolve("clip");
        } else {
          resolve("video");
        }
      };
      video.onerror = () => {
        resolve("video"); // default to horizontal if error
      };
      video.src = URL.createObjectURL(file);
    });
  };